<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-clipboard-list"
        texto-titulo="Legajos"
        :to-create-action="{ name: 'NuevoLegajo' }"
        to-create-text="Nuevo legajo"
      />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Buscar por N° de legajo</h5>
                  <DataList
                    ref="datatable"
                    url="/legajos"
                    :fields="fields"
                    :rowClick="verLegajo"
                  ></DataList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import DataList from "@/components/layouts/DataList";
export default {
  name: "ListarLegajos",
  components: {
    TituloComponente,
    DataList,
  },
  data() {
    return {
      legajo: [],
      fields: [
        {
          name: "persona.apellido",
          label: "",
          type: "title",
          class: "text-alternate",
          append: '-'
        },
        {
          name: "persona.nombre",
          label: "",
          type: "title",
          class: "text-alternate",
        },
        {
          name: "seccion.descripcion",
          label: "Seccion",
          type: "field",
          class: "",
        },
        {
          name: "numero",
          label: "legajo N°",
          type: "field",
          class: "",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    verLegajo(legajo) {
      //alert(liquidacion.id);
      this.$router.push({ name: "VerLegajo", params: { id: legajo.id } });
    },
  },
};
</script>
